import { Route } from '@angular/router';
import { authGuard } from '@auth';
import { MainLayoutComponent } from '@layout';

export const appRoutes: Route[] = [
  {
    path: 'auth',
    loadChildren: () => import('@auth').then((mod) => mod.AUTH_ROUTES),
  },
  {
    path: '',
    canActivate: [authGuard],
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('@dashboard').then((mod) => mod.DASHBOARD_ROUTES),
      },
      {
        path: 'aid-types',
        loadChildren: () =>
          import('@aid-types').then((mod) => mod.AID_TYPES_ROUTES),
      },
      {
        path: 'metrics',
        loadChildren: () =>
          import('@metrics').then((mod) => mod.METRICS_ROUTES),
      },
      {
        path: 'aid-recipient-types',
        loadChildren: () =>
          import('@aid-recipient-types').then(
            (mod) => mod.AID_RECIPIENT_TYPES_ROUTES
          ),
      },
      {
        path: 'aid-recipient-categories',
        loadChildren: () =>
          import('@aid-recipient-categories').then(
            (mod) => mod.AID_RECIPIENT_CATEGORIES_ROUTES
          ),
      },
      {
        path: 'aid-recipients',
        loadChildren: () =>
          import('@aid-recipients').then((mod) => mod.AID_RECIPIENTS_ROUTES),
      },
      {
        path: 'issue-aid',
        loadChildren: () =>
          import('@issue-aid').then((mod) => mod.ISSUE_AID_ROUTES),
      },
      {
        path: 'received-aid',
        loadChildren: () =>
          import('@received-aid').then((mod) => mod.RECEIVED_AID_ROUTES),
      },
      {
        path: 'aid-donor-types',
        loadChildren: () =>
          import('@aid-donor-types').then((mod) => mod.AID_DONOR_TYPES_ROUTES),
      },
      {
        path: 'aid-donors',
        loadChildren: () =>
          import('@aid-donors').then((mod) => mod.AID_DONORS_ROUTES),
      },
      {
        path: 'aid-recipient-groups',
        loadChildren: () =>
          import('@aid-recipient-groups').then(
            (mod) => mod.AID_RECIPIENT_GROUPS_ROUTES
          ),
      },
      {
        path: '**',
        loadComponent: () => import('@layout').then((c) => c.NotFoundComponent),
      },
    ],
  },
];
